import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import {
    Paper,
    RadioGroup,
    Radio,
    FormControlLabel,
    FormHelperText,
} from '@material-ui/core';
import DialogContentText from '@material-ui/core/DialogContentText';
import { makeStyles } from '@material-ui/core/styles';
import { useIntl } from 'react-intl';
import GridItem from '../../components/Grid/GridItem';
import CustomTypography from '../../components/Typography/CustomTypography';
import GridContainer from '../../components/Grid/GridContainer';
import TableProductPaymentDetail from '../../components/TableProductPaymentDetail/TableProductPaymentDetail';
import { headerTableOrder, lavenderTableOrder } from '../../assets/jss/global';
import styles from '../../assets/jss/pages/CartViewerStyle';
import Button from '../../components/Button/CustomButton';
import FormDialog from '../../components/Dialog/FormDialog';
import CleanableInput from '../../components/Input/CleanableInput';
import Validation from '../../common/Validation';
import SelectorInput from '../../components/Input/SelectorInput';
import { locationOption } from '../../common/Constants';
import ConfirmDialog from '../../components/Dialog/ConfirmDialog';
import Snackbar from '../../components/Snackbar/Snackbar';
import InputHasUnitAndCleanable from '../../components/Input/InputHasUnitAndCleanable';
import { ErrorGetToken } from '../../common/ErrorGetToken';
import Loader from '../../components/Loader/Loader';
import { platform, PLATFORM } from '../../utils/getPlatform';

const useStyles = makeStyles(styles);

const DialogProcessOrderProduct = ({
    isLoading,
    isOpen,
    handleClose,
    eventName,
    getListProductCart,
    clearProduct,
    listProductOrder,
    userProfile,
    getUserProfile,
    clearUserProfile,
    eventInfo,
    orderProduct,
    clearOrderProduct,
    successOrder,
    errorOrder,
    getCount,
    getListHistoryOrder,
    customText,
    customColor,
    customPersonInfo,
    locale,
}) => {
    const classes = useStyles(customColor);
    const intl = useIntl();

    const accountType = { card: '2', credit: '1' };
    const [listProduct, setListProduct] = useState([]);
    const [titleProduct, setTitleProduct] = useState([]);
    const [listSellProduct, setListSellProduct] = useState([]);
    const [validateResults, setValidateResults] = useState({});
    const [params, setParams] = useState({
        payment_method: 0,
        end_month: +new Date().getMonth() + 1,
        end_year: +new Date().getFullYear(),
        firstName: '',
        lastName: '',
        zipCode: '',
        address: '',
        location: '',
        phoneNumber: '',
        workPlace: '',
        department: '',
    });
    const [isOpenConfirmSuccess, setIsOpenConfirmSuccess] = useState({ open: false, content: '', success: false });
    const [snackbar, setSnackbar] = useState({ isOpen: false, type: 'success', message: '' });

    useEffect(() => {
        if (isOpen) {
            getListProductCart({ language: locale });
            getUserProfile({ language: locale });
            setParams({
                payment_method: 0,
                end_month: +new Date().getMonth() + 1,
                end_year: +new Date().getFullYear(),
                firstName: '',
                lastName: '',
                zipCode: '',
                address: '',
                location: '',
                phoneNumber: '',
                workPlace: '',
                department: '',
            });
        }
        return () => {
            clearProduct();
            clearUserProfile();
        };
    }, [isOpen, locale]);

    useEffect(() => {
        if (!_.isEmpty(listProductOrder)) {
            setListProduct(listProductOrder.data);
        }
    }, [listProductOrder]);

    useEffect(() => {
        if (listProduct) {
            allSellProduct();
            titleSellProduct();
        }
    }, [listProduct]);

    useEffect(() => {
        if (!_.isEmpty(userProfile)) {
            // eslint-disable-next-line no-nested-ternary
            const payment = eventInfo.has_bank_payment && eventInfo.has_credit_payment ? 0 : eventInfo.has_bank_payment ? '2' : eventInfo.has_credit_payment ? '1' : 0;
            setParams({
                ...params,
                firstName: userProfile.first_name,
                lastName: userProfile.last_name,
                zipCode: userProfile.zip_code,
                address: userProfile.address,
                location: userProfile.location,
                phoneNumber: userProfile.phone_number,
                workPlace: userProfile.work_place,
                department: userProfile.department,
                payment_method: payment,
            });
        }
    }, [userProfile]);

    useEffect(() => {
        if (successOrder) {
            getCount();
            clearOrderProduct();
            handleClose();
            if (+params.payment_method === 1) {
                setIsOpenConfirmSuccess({
                    open: true,
                    content: intl.formatMessage({ id: 'shopping.completeOrder' }),
                    success: true,
                });
            } else {
                setIsOpenConfirmSuccess({
                    open: true,
                    content: getContent(),
                    success: true,
                });
            }
        }
    }, [successOrder]);

    useEffect(() => {
        if (!_.isEmpty(errorOrder)) {
            handleClose();
            if (+params.payment_method === 1) {
                setIsOpenConfirmSuccess({ open: true, content: errorOrder?.message?.message, success: false });
            } else {
                setSnackbar({ isOpen: true, type: 'error', message: errorOrder.message.message });
            }
            clearOrderProduct();
        }
    }, [errorOrder]);

    const getContent = () => (
        <>
            <DialogContentText style={{ textAlign: 'left', color: customColor?.contents_text_color }}>
                {intl.formatMessage({ id: 'common.completeApplication' })}
            </DialogContentText>
            <DialogContentText style={{ textAlign: 'left', color: customColor?.contents_text_color }}>
                {intl.formatMessage({ id: 'common.emailBillDetail' })}
            </DialogContentText>
            <DialogContentText style={{ textAlign: 'left', color: customColor?.contents_text_color }}>
                {intl.formatMessage({ id: 'common.confirm' })}
            </DialogContentText>
        </>
    );

    const handleSuccessDialog = () => {
        if (isOpenConfirmSuccess.success) {
            getListProductCart({ language: locale });
            getListHistoryOrder({ page_size: 10, language: locale });
        }
        setIsOpenConfirmSuccess({ open: false, content: '', success: false });
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, isOpen: false });
    };

    const titleSellProduct = () => {
        const title = listProduct.map((item) => [item.full_name]);
        setTitleProduct(title);
    };

    const sellProduct = (data) => {
        const product = [];
        (data.products || []).forEach((item) => {
            product.push([
                item.name,
                `${intl.formatNumber(item.price)}${intl.formatMessage({ id: 'common.yen' })}`,
                +item.quantity,
            ]);
        });
        product.push([
            intl.formatMessage({ id: 'shopping.postage' }),
            `${intl.formatNumber(data.shipping_cost)}${intl.formatMessage({ id: 'common.yen' })}`, '']);
        product.push([
            intl.formatMessage({ id: 'shopping.subtotal' }),
            `${intl.formatNumber(data.price_total)}${intl.formatMessage({ id: 'common.yen' })}`, data.quantity_total]);
        return product;
    };

    const allSellProduct = () => {
        const allSell = listProduct.map((item) => sellProduct(item));
        setListSellProduct(allSell);
    };

    const handleSetParams = useCallback((field, valueChange) => {
        setParams((prevParams) => ({ ...prevParams, [field]: valueChange }));
    }, []);

    const validate = () => {
        const validateRules = {
            payment_method: [
                () => Validation.isNumberNotZero(+params.payment_method),
            ],
            first_name: [
                () => Validation.isNotEmpty(params.firstName),
                () => Validation.validateMaxLength(params.firstName, 255),
            ],
            last_name: [
                () => Validation.isNotEmpty(params.lastName),
                () => Validation.validateMaxLength(params.lastName, 255),
            ],
            zip_code: [
                () => Validation.isNotEmpty(params.zipCode),
                () => Validation.validateMaxLength(params.zipCode, 255),
            ],
            address: [
                () => Validation.isNotEmpty(params.address),
                () => Validation.validateMaxLength(params.address, 1000),
            ],
            phone_number: [
                () => Validation.validatePhoneNumber(params.phoneNumber && params.phoneNumber.trim()),
            ],
            work_place: [
                () => Validation.isNotEmpty(params.workPlace),
                () => Validation.validateMaxLength(params.workPlace, 255),
            ],
            department: [
                () => Validation.validateMaxLength(params.department, 255),
            ],
        };
        if (params.payment_method === '1') {
            const currentDate = new Date(+new Date().getFullYear(), +new Date().getMonth() + 1);
            const dateExpired = new Date(+params.end_year, +params.end_month);
            validateRules.id_card = [
                () => Validation.isNotEmpty(params.id_card),
                () => Validation.validateLimitNumber(params.id_card, 14),
            ];
            validateRules.user_name = [
                () => Validation.isNotEmpty(params.user_name),
                () => Validation.validateMaxLength(params.user_name, 64),
            ];
            validateRules.security_code = [
                () => Validation.isNotEmpty(params.security_code),
                () => Validation.validateLimitNumber(params.security_code, 3),
            ];
            validateRules.expiration_date = [
                () => Validation.validateCreditExpired(currentDate, dateExpired),
            ];
        }

        const validateResult = Validation.validateAllRules(validateRules);
        if (Object.keys(validateResult).length > 0) {
            setValidateResults(validateResult);
            window.scrollTo(0, 0);
            return false;
        }
        setValidateResults({});
        return true;
    };

    const optionYear = () => {
        let year = {};
        const currentYear = new Date().getFullYear();
        // eslint-disable-next-line no-return-assign
        Array.from(Array(20).keys()).forEach((item) => year = { ...year, [currentYear + item]: +currentYear + item });
        return year;
    };

    const optionMonth = () => {
        let month = {};
        // eslint-disable-next-line no-return-assign
        Array.from(Array(12).keys()).forEach((item) => month = { ...month, [+item + 1]: item + 1 });
        return month;
    };

    const handleInputPostalCode = (valueInput) => {
        handleSetParams('zipCode', valueInput);
        valueInput = valueInput.trim();
        const code = valueInput.substr(0, 3);
        if (code && code.length === 3 && valueInput.length === 7) {
            const pathPostal = process.env.REACT_APP_POSTAL_URL || '';
            fetch(`${pathPostal}/postal/${code}.json`)
                .then((res) => res.json())
                .then((data) => {
                    const d = data.find((it) => it[valueInput]);
                    handleSetParams('address', d[valueInput][0]);
                }).catch(() => {
                    // TODO
                });
        } else {
            handleSetParams('address', '');
        }
    };

    const registerAction = () => (
        <GridContainer
            direction="row"
            justify="center"
            alignItems="center"
        >
            <Button
                color="navy"
                round
                gradient
                className={classes.buttonSmall}
                onClick={() => handleOrderProduct()}
                buttonTextColor={customColor?.button_text_color}
                buttonBackgroundColor={customColor?.button_background_color?.common_button}
            >
                <b>{customText?.button_name?.order_with_contents || intl.formatMessage({ id: 'shopping.orderContent' })}</b>
            </Button>
        </GridContainer>
    );

    const checkUndefined = (values) => (!_.isUndefined(values) ? values.trim() : '');

    const handleOrderProduct = () => {
        if (validate()) {
            const dataSubmit = {
                payment_method: +params.payment_method,
                first_name: checkUndefined(params.firstName),
                last_name: checkUndefined(params.lastName),
                work_place: checkUndefined(params.workPlace),
                department: checkUndefined(params.department),
                location: checkUndefined(params.location),
                zip_code: checkUndefined(params.zipCode),
                address: checkUndefined(params.address),
                phone_number: checkUndefined(params.phoneNumber),
            };
            handleClose();
            if (params.payment_method === '2') {
                orderProduct({ data: dataSubmit, language: locale });
            } else if (params.payment_method === '1') {
                sent();
            }
        }
    };

    const sent = () => {
        // eslint-disable-next-line no-undef
        const paygentToken = new PaygentToken();
        paygentToken.createToken(
            `${process.env.REACT_APP_MERCHANT_ID_GET_TOKEN}`,
            `${process.env.REACT_APP_KEY_GENERATE_GET_TOKEN}`,
            {
                card_number: params.id_card,
                expire_year: +params.end_year % 100,
                expire_month: +params.end_month,
                name: params.user_name,
                cvc: params.security_code,
            },
            execPurchase,
        );
    };

    const execPurchase = (response) => {
        if (response.result === '0000') {
            const data = {
                token: response.tokenizedCardObject.token,
                masked_card_number: response.tokenizedCardObject.masked_card_number,
                valid_until: response.tokenizedCardObject.valid_until,
                fingerprint: response.tokenizedCardObject.fingerprint,
                hc: response.hc,
                payment_method: +params.payment_method,
                first_name: checkUndefined(params.firstName),
                last_name: checkUndefined(params.lastName),
                work_place: checkUndefined(params.workPlace),
                department: checkUndefined(params.department),
                location: checkUndefined(params.location),
                zip_code: checkUndefined(params.zipCode),
                address: checkUndefined(params.address),
                phone_number: checkUndefined(params.phoneNumber),
            };
            orderProduct(data);
        } else {
            setIsOpenConfirmSuccess({ open: true, content: ErrorGetToken[locale][+response.result], success: false });
        }
    };

    return (
        <>
            <Loader isLoading={isLoading} />
            <FormDialog
                title={intl.formatMessage({ id: 'shopping.oderProcedure2' })}
                titleAlign="center"
                visibleCustomizeCloseBtn
                isOpen={isOpen}
                handleClose={handleClose}
                actions={registerAction()}
                customColor={customColor?.contents_text_color}
            >
                <GridContainer className={classes.dialogOrder}>
                    <GridItem className={classNames({ [classes.noPadding]: platform !== PLATFORM.OTHER })}>
                        <Paper elevation={3} classes={{ root: classes.room }}>
                            <GridItem xs={12} md={12} className={classes.titleDetail}>
                                <CustomTypography variant="h6" customColor={customColor?.contents_text_color}>
                                    {intl.formatMessage({ id: 'shopping.breakdown' })}
                                </CustomTypography>
                            </GridItem>
                            <GridItem xs={12} md={12}>
                                <TableProductPaymentDetail
                                    cellColor={customColor?.shop_table?.title_background_color || headerTableOrder}
                                    colorRowTitle={customColor?.shop_table?.sub_title_background_color || lavenderTableOrder}
                                    onClick={() => {}}
                                    tableHead={[
                                        customText?.field_name?.product_name || intl.formatMessage({ id: 'productRegister.productName' }),
                                        intl.formatMessage({ id: 'shopping.unitPrice' }),
                                        intl.formatMessage({ id: 'shopping.quantity' }),
                                    ]}
                                    tableHeadWidth={['60%', '25%', '15%']}
                                    tableTitleRow={titleProduct}
                                    tableData={listSellProduct}
                                    hover={false}
                                    pointerLess
                                    className={classes.customTableOrder}
                                    lengthCol={3}
                                    cellBackgroundColor={customColor?.shop_table?.record_background_color}
                                    cellTextColorHear={customColor?.contents_text_color}
                                    cellTextColorBody={customColor?.contents_text_color}
                                />
                            </GridItem>
                            <GridItem xs={12} md={12} className={classes.spacing}>
                                <CustomTypography variant="h5" xs={12} bold className={classes.spacingTotalPrice} customColor={customColor?.contents_text_color}>
                                    {`${intl.formatMessage({ id: 'shopping.total' })}:`}
                                    <span className={classes.allTotalPrice}>
                                        {`${intl.formatNumber(listProductOrder.all_total_price)}${intl.formatMessage({ id: 'common.yen' })}`}
                                    </span>
                                </CustomTypography>
                            </GridItem>
                        </Paper>
                    </GridItem>
                    <GridItem className={classNames({ [classes.infoOrder]: platform === PLATFORM.OTHER, [classes.marginTopOrder]: platform !== PLATFORM.OTHER })}>
                        <CustomTypography bold variant="h6" customColor={customColor?.contents_text_color}>
                            {intl.formatMessage({ id: 'shopping.selectPaymentMethod' })}
                        </CustomTypography>
                        <GridItem className={classNames({ [classes.noPadding]: platform !== PLATFORM.OTHER })}>
                            { !eventInfo.has_credit_payment && !eventInfo.has_bank_payment && (
                                <CustomTypography variant="h7" customColor={customColor?.contents_text_color}>
                                    {intl.formatMessage({ id: 'common.noPaymentMethod' })}
                                </CustomTypography>
                            )}
                            <RadioGroup
                                aria-label="payment_method"
                                name="payment_method"
                                value={params.payment_method}
                                onChange={(e) => setParams({
                                    ...params,
                                    payment_method: e.target.value,
                                })}
                                row
                            >
                                {eventInfo.has_credit_payment && (
                                    <FormControlLabel
                                        value={accountType.credit}
                                        control={<Radio color="primary" checked={params.payment_method === '1'} />}
                                        label={<CustomTypography customColor="#4b4b4b">{intl.formatMessage({ id: 'common.credit' })}</CustomTypography>}
                                        className={classes.colorIconRadio}
                                    />
                                )}
                                {eventInfo.has_bank_payment && (
                                    <FormControlLabel
                                        value={accountType.card}
                                        control={<Radio color="primary" checked={params.payment_method === '2'} />}
                                        label={<CustomTypography customColor="#4b4b4b">{intl.formatMessage({ id: 'common.bankTransfer' })}</CustomTypography>}
                                        className={eventInfo.has_credit_payment && classes.radioButton}
                                    />
                                )}
                            </RadioGroup>
                            <FormHelperText error className="MuiFormHelperText-contained">
                                {validateResults.payment_method
                                    ? intl.formatMessage({ id: validateResults.payment_method.message }) : ''}
                            </FormHelperText>
                            {params.payment_method === '1' && (
                                <GridItem className={classNames({ [classes.paperInfoOrder]: true, [classes.noPaddingOrder]: platform !== PLATFORM.OTHER })}>
                                    <GridContainer className={classes.spacingBottom}>
                                        <GridItem xs={12} md={3} className={classes.leftTitle}>
                                            <CustomTypography required bold customColor={customColor?.contents_text_color}>
                                                {intl.formatMessage({ id: 'common.cardNumber' })}
                                            </CustomTypography>
                                        </GridItem>
                                        <GridItem xs={12} md={8} className={classes.rightInput}>
                                            <InputHasUnitAndCleanable
                                                classes={{ root: classes.colorTextInput }}
                                                defaultValue={params.id_card}
                                                maxLength={16}
                                                onChange={(value) => handleSetParams('id_card', value)}
                                                error={!!validateResults.id_card}
                                                helperText={validateResults.id_card
                                                    ? intl.formatMessage({ id: validateResults.id_card.message }, { minNumber: 14, maxNumber: 16 }) : ''}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer className={validateResults.expiration_date ? '' : classes.spacingBottom}>
                                        <GridItem xs={12} md={3} className={classes.leftTitle}>
                                            <CustomTypography required bold customColor={customColor?.contents_text_color}>
                                                {intl.formatMessage({ id: 'common.dateOfExpiry' })}
                                            </CustomTypography>
                                        </GridItem>
                                        <GridItem xs={12} md={8} className={!validateResults.expiration_date ? classes.rightSelect : classes.rightSelectNoMargin}>
                                            <SelectorInput
                                                isCustomColor
                                                valueSelected={+params.end_month}
                                                optionList={optionMonth()}
                                                onChange={(valueInput) => handleSetParams('end_month', optionMonth()[valueInput])}
                                                error={!!validateResults.expiration_date}
                                                customColor={customColor?.contents_text_color}
                                            />
                                            <span className={classes.titleMonth}>{intl.formatMessage({ id: 'common.month' })}</span>
                                            <SelectorInput
                                                isCustomColor
                                                valueSelected={+params.end_year}
                                                optionList={optionYear()}
                                                onChange={(valueInput) => handleSetParams('end_year', optionYear()[valueInput])}
                                                error={!!validateResults.expiration_date}
                                                customColor={customColor?.contents_text_color}
                                            />
                                            <span className={classes.titleYear}>{intl.formatMessage({ id: 'common.year' })}</span>
                                        </GridItem>
                                    </GridContainer>
                                    {!!validateResults.expiration_date && (
                                        <GridContainer className={classes.spacingBottom}>
                                            <GridItem xs={12} md={3} className={classes.leftTitle} />
                                            <GridItem xs={12} md={8} className={classes.rightInput}>
                                                <FormHelperText error className="MuiFormHelperText-contained">
                                                    {validateResults.expiration_date
                                                        ? intl.formatMessage({ id: validateResults.expiration_date.message }) : ''}
                                                </FormHelperText>
                                            </GridItem>
                                        </GridContainer>
                                    )}
                                    <GridContainer className={classes.spacingBottom}>
                                        <GridItem xs={12} md={3} className={classes.leftTitle}>
                                            <CustomTypography required bold customColor={customColor?.contents_text_color}>
                                                {intl.formatMessage({ id: 'common.nominalName' })}
                                            </CustomTypography>
                                        </GridItem>
                                        <GridItem xs={12} md={8} className={classes.rightInput}>
                                            <CleanableInput
                                                classes={{ root: classes.colorTextInput }}
                                                defaultValue={params.user_name}
                                                onChange={(value) => handleSetParams('user_name', value)}
                                                error={!!validateResults.user_name}
                                                helperText={validateResults.user_name
                                                    ? intl.formatMessage({ id: validateResults.user_name.message }, { maxLength: 64 }) : ''}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer className={classes.spacingBottom}>
                                        <GridItem xs={12} md={3} className={classes.leftTitle}>
                                            <CustomTypography required bold customColor={customColor?.contents_text_color}>
                                                {intl.formatMessage({ id: 'common.securityCode' })}
                                            </CustomTypography>
                                        </GridItem>
                                        <GridItem xs={12} md={8} className={classes.rightInput}>
                                            <InputHasUnitAndCleanable
                                                classes={{ root: classes.colorTextInput }}
                                                defaultValue={params.security_code}
                                                maxLength={4}
                                                onChange={(value) => handleSetParams('security_code', value)}
                                                error={!!validateResults.security_code}
                                                helperText={validateResults.security_code
                                                    ? intl.formatMessage({ id: validateResults.security_code.message }, { minNumber: 3, maxNumber: 4 }) : ''}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                            )}
                        </GridItem>
                    </GridItem>
                    <GridItem className={classNames({ [classes.infoOrder]: platform === PLATFORM.OTHER, [classes.marginTopOrder]: platform !== PLATFORM.OTHER })}>
                        <CustomTypography bold variant="h6" className={classes.rightInput} customColor={customColor?.contents_text_color}>
                            {intl.formatMessage({ id: 'shopping.shipInfo' })}
                        </CustomTypography>
                        <GridItem className={classNames({ [classes.noPadding]: platform !== PLATFORM.OTHER })}>
                            <GridItem className={classNames({ [classes.paperInfoOrder]: true, [classes.noPaddingOrder]: platform !== PLATFORM.OTHER })}>
                                <GridContainer>
                                    <GridItem xs={12} md={3}>
                                        <CustomTypography required bold customColor={customColor?.contents_text_color}>
                                            {customPersonInfo?.field_name?.name || intl.formatMessage({ id: 'name' })}
                                        </CustomTypography>
                                    </GridItem>
                                    <GridItem xs={12} md={8} className={classes.rightInfoInput}>
                                        <GridContainer className={classes.spacingBottom}>
                                            <GridItem xs={12} md={6}>
                                                <CustomTypography bold customColor={customColor?.contents_text_color}>
                                                    {intl.formatMessage({ id: 'lastName' })}
                                                </CustomTypography>
                                                <CleanableInput
                                                    classes={{ root: classes.colorTextInput }}
                                                    defaultValue={params.firstName}
                                                    onChange={(valueInput) => handleSetParams('firstName', valueInput)}
                                                    error={!!validateResults.first_name}
                                                    helperText={validateResults.first_name
                                                        ? intl.formatMessage(
                                                            { id: validateResults.first_name.message },
                                                            { maxLength: 255 },
                                                        ) : ''}
                                                />
                                            </GridItem>
                                            <GridItem xs={12} md={6}>
                                                <CustomTypography bold customColor={customColor?.contents_text_color}>
                                                    {intl.formatMessage({ id: 'firstName' })}
                                                </CustomTypography>
                                                <CleanableInput
                                                    classes={{ root: classes.colorTextInput }}
                                                    defaultValue={params.lastName}
                                                    onChange={(valueInput) => handleSetParams('lastName', valueInput)}
                                                    error={!!validateResults.last_name}
                                                    helperText={validateResults.last_name
                                                        ? intl.formatMessage(
                                                            { id: validateResults.last_name.message },
                                                            { maxLength: 255 },
                                                        ) : ''}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>
                                </GridContainer>

                                <GridContainer className={classes.spacing}>
                                    <GridItem xs={12} md={3}>
                                        <CustomTypography required bold customColor={customColor?.contents_text_color}>
                                            {customPersonInfo?.field_name?.zip_code || intl.formatMessage({ id: 'zipCode' })}
                                        </CustomTypography>
                                    </GridItem>
                                    <GridItem xs={12} md={8} className={classes.rightInfoInput}>
                                        <GridContainer>
                                            <GridItem xs={12} md={12}>
                                                <CleanableInput
                                                    classes={{ root: classes.colorTextInput }}
                                                    defaultValue={params.zipCode}
                                                    onChange={(valueInput) => handleInputPostalCode(valueInput)}
                                                    error={!!validateResults.zip_code}
                                                    helperText={validateResults.zip_code
                                                        ? intl.formatMessage(
                                                            { id: validateResults.zip_code.message },
                                                            { maxLength: 255 },
                                                        ) : ''}
                                                />
                                            </GridItem>
                                            <GridItem>
                                                <CustomTypography customColor={customColor?.contents_text_color}>
                                                    {intl.formatMessage({ id: 'registerViewer.exampleNumber' })}
                                                </CustomTypography>
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>
                                </GridContainer>

                                <GridContainer className={classes.spacing}>
                                    <GridItem xs={12} md={3}>
                                        <CustomTypography required bold customColor={customColor?.contents_text_color}>
                                            {customPersonInfo?.field_name?.address || intl.formatMessage({ id: 'address' })}
                                        </CustomTypography>
                                    </GridItem>
                                    <GridItem xs={12} md={8} className={classes.rightInfoInput}>
                                        <GridContainer>
                                            <GridItem xs={12} md={12}>
                                                <CleanableInput
                                                    classes={{ root: classes.colorTextInput }}
                                                    defaultValue={params.address}
                                                    onChange={(valueInput) => handleSetParams('address', valueInput)}
                                                    error={!!validateResults.address}
                                                    helperText={validateResults.address
                                                        ? intl.formatMessage(
                                                            { id: validateResults.address.message },
                                                            { maxLength: 1000 },
                                                        ) : ''}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>
                                </GridContainer>

                                <GridContainer className={classes.spacing}>
                                    <GridItem xs={12} md={3}>
                                        <CustomTypography bold customColor={customColor?.contents_text_color}>
                                            {customPersonInfo?.field_name?.country_region || intl.formatMessage({ id: 'common.country' })}
                                        </CustomTypography>
                                    </GridItem>
                                    <GridItem xs={12} md={8} className={classes.rightInfoInput}>
                                        <GridContainer>
                                            <GridItem xs={12} md={8}>
                                                <SelectorInput
                                                    isCustomColor
                                                    valueSelected={params.location ? params.location : '0'}
                                                    optionList={locationOption[locale]}
                                                    onChange={(valueInput) => handleSetParams('location', valueInput)}
                                                    customColor={customColor?.contents_text_color}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>
                                </GridContainer>

                                <GridContainer className={classes.spacing}>
                                    <GridItem xs={12} md={3}>
                                        <CustomTypography bold customColor={customColor?.contents_text_color}>
                                            {customPersonInfo?.field_name?.phone_number || intl.formatMessage({ id: 'phoneNumber' })}
                                        </CustomTypography>
                                    </GridItem>
                                    <GridItem xs={12} md={8} className={classes.rightInfoInput}>
                                        <GridContainer>
                                            <GridItem xs={12} md={12}>
                                                <CleanableInput
                                                    classes={{ root: classes.colorTextInput }}
                                                    defaultValue={params.phoneNumber}
                                                    onChange={(valueInput) => handleSetParams('phoneNumber', valueInput)}
                                                    error={!!validateResults.phone_number}
                                                    helperText={validateResults.phone_number
                                                        ? intl.formatMessage(
                                                            { id: validateResults.phone_number.message },
                                                            { maxLength: 255 },
                                                        ) : ''}
                                                />
                                            </GridItem>
                                            <GridItem>
                                                <CustomTypography customColor={customColor?.contents_text_color}>
                                                    {intl.formatMessage({ id: 'registerViewer.exampleTel' })}
                                                </CustomTypography>
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>
                                </GridContainer>

                                <GridContainer className={classes.spacing}>
                                    <GridItem xs={12} md={3}>
                                        <CustomTypography required bold customColor={customColor?.contents_text_color}>
                                            {customPersonInfo?.field_name?.work_place || intl.formatMessage({ id: 'workplace' })}
                                        </CustomTypography>
                                    </GridItem>
                                    <GridItem xs={12} md={8} className={classes.rightInfoInput}>
                                        <GridItem xs={12} md={12}>
                                            <CleanableInput
                                                classes={{ root: classes.colorTextInput }}
                                                defaultValue={params.workPlace}
                                                onChange={(valueInput) => handleSetParams('workPlace', valueInput)}
                                                error={!!validateResults.work_place}
                                                helperText={validateResults.work_place
                                                    ? intl.formatMessage(
                                                        { id: validateResults.work_place.message },
                                                        { maxLength: 255 },
                                                    ) : ''}
                                            />
                                            <CustomTypography customColor={customColor?.contents_text_color}>
                                                {intl.formatMessage({ id: 'registerViewer.workPlace' }, {
                                                    workPlace: customPersonInfo?.field_name?.work_place || intl.formatMessage({ id: 'workplace' }),
                                                })}
                                            </CustomTypography>
                                        </GridItem>
                                    </GridItem>
                                </GridContainer>

                                <GridContainer className={classes.spacing}>
                                    <GridItem xs={12} md={3}>
                                        <CustomTypography bold customColor={customColor?.contents_text_color}>
                                            {customPersonInfo?.field_name?.department || intl.formatMessage({ id: 'department' })}
                                        </CustomTypography>
                                    </GridItem>
                                    <GridItem xs={12} md={8} className={classes.rightInfoInput}>
                                        <GridContainer>
                                            <GridItem xs={12} md={12}>
                                                <CleanableInput
                                                    classes={{ root: classes.colorTextInput }}
                                                    defaultValue={params.department}
                                                    onChange={(valueInput) => handleSetParams('department', valueInput)}
                                                    error={!!validateResults.department}
                                                    helperText={validateResults.department
                                                        ? intl.formatMessage(
                                                            { id: validateResults.department.message },
                                                            { maxLength: 255 },
                                                        ) : ''}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                        </GridItem>
                    </GridItem>
                </GridContainer>
            </FormDialog>
            <ConfirmDialog
                title={intl.formatMessage({ id: 'confirm' })}
                contents={isOpenConfirmSuccess.content}
                open={isOpenConfirmSuccess.open}
                handleClose={handleSuccessDialog}
                customColor={customColor}
            />
            <Snackbar
                open={snackbar.isOpen}
                onClose={handleCloseSnackbar}
                message={snackbar.message}
                severity={snackbar.type}
            />
        </>
    );
};

DialogProcessOrderProduct.defaultProps = {
    isLoading: false,
    isOpen: false,
    handleClose: () => {},
    eventName: '',
    getListProductCart: () => {},
    clearProduct: () => {},
    listProductOrder: {},
    userProfile: {},
    getUserProfile: () => {},
    clearUserProfile: () => {},
    eventInfo: {},
    orderProduct: () => {},
    clearOrderProduct: () => {},
    successOrder: false,
    errorOrder: {},
    getCount: {},
    getListHistoryOrder: () => {},
    customText: {},
    customColor: {},
    customPersonInfo: {},
    locale: 'ja',
};

DialogProcessOrderProduct.propTypes = {
    isLoading: PropTypes.bool,
    isOpen: PropTypes.bool,
    handleClose: PropTypes.func,
    eventName: PropTypes.string,
    getListProductCart: PropTypes.func,
    clearProduct: PropTypes.func,
    listProductOrder: PropTypes.oneOfType([() => null, PropTypes.object]),
    userProfile: PropTypes.oneOfType([() => null, PropTypes.object]),
    getUserProfile: PropTypes.func,
    clearUserProfile: PropTypes.func,
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    orderProduct: PropTypes.func,
    clearOrderProduct: PropTypes.func,
    successOrder: PropTypes.bool,
    errorOrder: PropTypes.oneOfType([() => null, PropTypes.object]),
    getCount: PropTypes.oneOfType([() => null, PropTypes.object]),
    getListHistoryOrder: PropTypes.func,
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
    customPersonInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    locale: PropTypes.string,
};

export default DialogProcessOrderProduct;
